import { FC } from "react";
import { IconProps } from "@/common/icons/types";
import { LOGO_GRAY } from "@/styles/colorsJS";

export const ClockIcon: FC<IconProps> = ({ color = LOGO_GRAY }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M18.3333 9.99935C18.3333 14.5993 14.6 18.3327 9.99996 18.3327C5.39996 18.3327 1.66663 14.5993 1.66663 9.99935C1.66663 5.39935 5.39996 1.66602 9.99996 1.66602C14.6 1.66602 18.3333 5.39935 18.3333 9.99935Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0917 12.6495L10.5083 11.1078C10.0583 10.8411 9.69165 10.1995 9.69165 9.67448V6.25781"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
